module.exports = __webpack_public_path__ + "static/media/ok.e11768b5.svg";